module.exports = __webpack_public_path__ + "static/img/jsmagic1pict4.7428ea6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jsmagic1pict4.jpg
// module id = Jn00
// module chunks = 0